export default "__VITE_ASSET__951c45a9__"